import { theme } from '../../ThemeContext/ThemeObject';
import { actionsMenu } from '../shared/styleClasses';

export const styles = {
  templatesPageContainer: {
    padding: '40px',
    rowGap: 4
  },
  templatesPageHeader: {
    fontWeight: 'bold',
    fontSize: '38px',
    color: '#666666'
  },
  actionsMenu,
  modalStyleOverrides: {
    height: 'auto',
    maxHeight: '84vh',
    width: '900px',
    padding: '40px'
  },
  modalContainer: {
    width: '100%',
    height: '100%',
    rowGap: 3,
    overflow: 'auto'
  },
  modalTitle: {
    fontWeight: 'bold',
    color: '#084D6D',
    fontSize: '25px'
  },
  createButtonItemList: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#666666',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  questionLibraryModalEmptyStateContainer: {
    alignItems: 'center',
    rowGap: 3,
    justifyContent: 'center',
    height: '400px'
  },
  questionLibraryModalEmptyStateMessage: {
    color: theme.palette.common.grey,
    fontWeight: 'bold',
    fontSize: '18px'
  }
};
